module.exports = "<ui-view><project-group-table></project-group-table></ui-view>";